import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import { PageHero, CTABand } from "@/components/Bits";
import { Cog } from "lucide-react";

const PARTS = ["Compressores", "Condensadores e evaporadores", "Válvulas e controles", "Motores e ventiladores", "Fluidos refrigerantes", "Componentes elétricos e automação"];

export default function Pecas() {
  const { openQuote } = useSite();
  return (
    <div>
      <PageHero eyebrow="Peças" title="Peças e componentes para reposição"
        subtitle="Fornecemos peças para manutenção e reposição dos principais componentes de sistemas de refrigeração."
        image="https://images.unsplash.com/photo-1620203853151-496c7228306c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PARTS.map((p) => (
            <div key={p} className="flex items-center gap-3 border border-[#27272A] bg-[#151618] p-6">
              <Cog className="h-6 w-6 text-[#FF5500]" />
              <span className="font-medium text-white">{p}</span>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Button data-testid="parts-request-button" onClick={() => openQuote({ equipment_type: "Peças / Componentes", source: "pecas" })}
            className="rounded-none bg-[#FF5500] px-8 py-6 text-base font-bold hover:bg-[#CC4400]">Solicitar Peça</Button>
        </div>
      </div>
      <CTABand title="Procurando uma peça específica?" text="Descreva o item e o equipamento — nós localizamos para você." />
    </div>
  );
}
